export default "__VITE_ASSET__BI2h2xZ___";